import React, { useEffect, useState, useRef } from "react";

const TeamSelector = ({
  onChange,
  appData,
  activeLeague,
  activeSeason,
  typeOfSelector,
  isActiveTeam,
  startDate,
  endDate,
}) => {
  const [team, setTeam] = useState(null);
  const [baseTeam, setBaseTeam] = useState(null);
  const activeTeamRef = useRef(null);

  useEffect(() => {
    if (onChange) {
      onChange(team, isActiveTeam, baseTeam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [team, onChange, baseTeam]);

  return (
    <div className="option-content">
      <label>Elige Equipo</label>
      <select
        value={team || ""}
        onChange={(e) => {
          if (activeTeamRef.current?.checked) {
            setBaseTeam(e.target.value);
          }
          setTeam(e.target.value);
        }}
        id="teamSelect"
        disabled={
          !(
            (activeLeague !== null && activeSeason !== null) ||
            (activeLeague !== null && startDate !== null && endDate !== null)
          )
        }
      >
        <option hidden value="">
          Selecciona equipo
        </option>
        {appData?.teams !== null &&
          appData?.teams
            .filter((team) =>
              team.history.some(
                (t) => t.season === activeSeason && t.league === activeLeague
              )
            )
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((team, index) => (
              <option key={index} value={team._id}>
                {team.name}
              </option>
            ))}
      </select>
      {typeOfSelector === "analytics" ? (
        <div className="flex_center_space-between">
          <input
            ref={activeTeamRef}
            onChange={(e) => {
              setBaseTeam(team);
            }}
            id="baseTeamSelect"
            type="checkbox"
          />
          <h3>Equipo base</h3>
        </div>
      ) : null}
    </div>
  );
};

export default TeamSelector;
